import React from 'react';
import { Link } from 'react-router-dom';

function HelpContactCard({
  title = 'Need more help',
  content = 'Get the help you need from our automated assistant, or contact an agent',
  linkContent = {
    text: 'Contact us',
    link: 'https://help.smallsmall.com/smallsmall/directories',
  },
}) {
  return (
    <section className="px-3 md:px-0">
      <div className="bg-[#F6F6F6] rounded-2xl md:py-10 md:px-28 p-10 max-w-2xl my-40 mx-auto text-center">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
        <p className="text-gray-700 mb-6">{content}</p>
        <Link
          to={`${linkContent.link}`}
          className="bg-[#FFDE11] text-base hover:bg-yellow-500 text-black font-semibold py-2 px-10 rounded-md inline-block transition duration-300"
          target="_blank"
        >
          {linkContent.text}
        </Link>
      </div>
    </section>
  );
}

export default HelpContactCard;
